import { VendorPayment } from './VendorPayment';
import { VendorDocument } from './VendorDocument';
export class VendorPaymentDetails {
  public paymentInvoice: VendorPayment;
  public VendorDocuments: VendorDocument[];
}



// WEBPACK FOOTER //
// ./src/app/models/VendorPaymentDetails.ts